import styled from 'styled-components';

import { BLACK, WHITE, PAGE_WIDTH } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const FONT_SIZE = '15px';
const FONT_SIZE_SMALL = '12px';
const GRAY_COLOR = '#a0a5a9';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column;
  max-width: ${PAGE_WIDTH}px;
  margin-bottom: 0 auto 10px auto;
`;
export const ImgContainer = styled.div`
  flex: 1 1 auto;
  height: calc(100vh - 260px);
  width: 100%;
  position: relative;
`;
export const Logo = styled.img`
  height: calc(100vh - 260px - 93%);
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  ${media.tabletP`
    width: 198px;
    bottom: 25px;
    height: unset;
  `};
`;
export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 34px 20px 0 20px;

  ${media.tabletP`
    padding: 34px 0 0 0;
  `};
`;

export const WrappedContentRow = styled(ContentRow)`
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: calc(100vh - (100vh - 260px + 219px)); // 100vh - 画像の高さ - 他要素の高さ

  ${media.tabletP`
    flex-wrap: nowrap;
    justify-content: center;
  `};
`;

export const ContentRowFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const DetailedDiagnosisButton = styled.button`
  background-color: ${GRAY_COLOR};
  border: none;
  color: ${WHITE};
  cursor: pointer;
  display: block;
  font-size: 13px;
  font-weight: 500;
  height: 47px;
  max-width: 300px;
  width: 300px;
  letter-spacing: 1px;
  line-height: 47px;
  margin: 0 1em 0 0;
  outline: none;
  padding: 0;
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }

  ${media.tabletL`
    align-items: center;
    display: flex;
    justify-content: center;
  `};

  ${media.tabletP`
    font-size: 18px;
    height: 67px;
    line-height: 67px;
    max-width: 300px;
    width: 300px;
  `};
`;

export const QuickDiagnosisButton = styled.button`
  background-color: ${WHITE};
  border: 1px solid ${GRAY_COLOR};
  color: ${BLACK};
  cursor: pointer;
  display: block;
  font-size: 13px;
  font-weight: 500;
  height: 47px;
  max-width: 300px;
  width: 300px;
  letter-spacing: 1px;
  line-height: 47px;
  margin: 0;
  outline: none;
  padding: 0;
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }

  ${media.tabletL`
    align-items: center;
    display: flex;
    justify-content: center;
  `};

  ${media.tabletP`
    font-size: 18px;
    height: 67px;
    line-height: 67px;
    max-width: 300px;
    width: 300px;
  `};
`;
export const HomeCareItemButton = styled.button`
  align-items: center;
  background-color: ${WHITE};
  border: none;
  color: ${BLACK};
  cursor: pointer;
  display: flex;
  font-size: ${FONT_SIZE_SMALL};
  font-weight: 500;
  height: 30px;
  letter-spacing: 1px;
  line-height: 30px;
  margin: 0 1em 0 0;
  max-width: 310px;
  outline: none;
  padding: 0;
  text-align: left;
  width: 310px;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }

  ${media.tabletL`
    align-items: center;
    display: flex;
    justify-content: center;
  `};

  ${media.tabletP`
    align-items: unset;
    display: block;
    font-size: 14px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  `};
`;
export const SalonMenuButton = styled.button`
  align-items: center;
  background-color: ${WHITE};
  border: none;
  color: ${BLACK};
  cursor: pointer;
  display: flex;
  font-size: ${FONT_SIZE_SMALL};
  font-weight: 500;
  height: 30px;
  letter-spacing: 1px;
  line-height: 30px;
  margin: 15px 0 0 0;
  max-width: 315px;
  outline: none;
  padding: 0;
  text-align: left;
  width: 315px;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }

  ${media.tabletL`
    align-items: center;
    display: flex;
    justify-content: center;
  `};

  ${media.tabletP`
    align-items: unset;
    display: block;
    font-size: 14px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    margin: 0;
  `};
`;
export const SublimicSiteButton = styled.button`
  background-color: #f1f1f1;
  border: none;
  color: ${BLACK};
  cursor: pointer;
  display: block;
  font-size: 11px;
  font-weight: 500;
  height: 29px;
  max-width: 100%;
  width: 100%;
  letter-spacing: 1px;
  line-height: 29px;
  margin: 0;
  outline: none;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 29px); // less than equal iOS 11.1
  padding-bottom: calc(env(safe-area-inset-bottom) + 29px); // greater than equal iOS 11.2

  span {
    display: inline-block;
    vertical-align: middle;
  }

  img {
    vertical-align: base-line;
    width: 12px;
    height: 10px;
    margin-left: 6px;
    transform: translateY(-4px);
  }

  ${media.tabletP`
    font-size: 12px;
    height: 42px;
    line-height: 42px;
    img {
      transform: translateY(0);
    }
    padding-bottom: 42px;
  `};
`;
export const IconButton = styled.i`
  color: ${BLACK};
  display: block;
  font-size: ${FONT_SIZE};
  font-weight: 500;
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  height: 29px;
  width: 29px;
  margin-right: ${props => (props.right ? '0px' : '8px')};
  margin-left: ${props => (props.right ? '8px' : '0px')};
  transform: translateY(-2px);

  ${media.tabletP`
    height: 24px;
    width: 24px;
    transform: ${props => (props.small ? 'translateY(2px)' : 'translateY(5px)')};
  `};
`;

export const ErrorMessage = styled.p`
  color: #f00;
  font-size: ${FONT_SIZE_SMALL};
  margin: 30px 20px -20px;
  ${media.tabletP`
    font-size: 18px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomePage/SublimicHomePage.style.js